/**
 * Transcription Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.1.21
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ManagementTranscriptionFilterRequest { 
    types?: Array<ManagementTranscriptionFilterRequest.TypesEnum>;
    langs?: Array<ManagementTranscriptionFilterRequest.LangsEnum>;
    text?: string;
    speaker?: string;
    clientId?: string;
    tagIds?: Array<string>;
    createdAtFrom?: number;
    createdAtTo?: number;
}
export namespace ManagementTranscriptionFilterRequest {
    export type TypesEnum = 'URL' | 'FILE' | 'RECORDING' | 'YOUTUBE';
    export const TypesEnum = {
        URL: 'URL' as TypesEnum,
        FILE: 'FILE' as TypesEnum,
        RECORDING: 'RECORDING' as TypesEnum,
        YOUTUBE: 'YOUTUBE' as TypesEnum
    };
    export type LangsEnum = 'MK' | 'EN' | 'AL';
    export const LangsEnum = {
        MK: 'MK' as LangsEnum,
        EN: 'EN' as LangsEnum,
        AL: 'AL' as LangsEnum
    };
}